export const planStatus = {
  PUBLIC: 'public',
  DRAFT: 'draft',
};

export const STUDENT_LIMIT_MIN = 10;
export const STUDENT_LIMIT_MAX = 1000;
export const PLAN_NAME_MAX_LENGTH = 255;
export const PRICE_MAX_LENGTH = 10;
